import { AXIS_X, AXIS_Y } from './constants';

export default (zone, el, arrowSize = 0) => {
  const elWidth = zone.axis === AXIS_X ? el.width + arrowSize : el.width;
  const elHeight = zone.axis === AXIS_Y ? el.height + arrowSize : el.height;
  const zr = Math.min(zone.width, elWidth) * Math.min(zone.height, elHeight);
  const er = elWidth * elHeight;
  return (zr / er) * 100;
};
